import styled from 'styled-components';
import { FormRow as StormFormRow } from '@amzn/storm-ui-column-form-kit';
import { Text } from '@amzn/storm-ui';

export const FormContainer = styled.div`
  padding: 1.25rem;
`;

export const StyledFormRow = styled(StormFormRow)`
  margin-bottom: 2.5rem;
`;

export const FieldContainer = styled.div`
  width: 25rem;
`;

export const ButtonRow = styled.div`
  margin-left: 11.5rem;
  margin-top: 1rem;
`;

export const InputFieldWrapper = styled.div`
  margin-bottom: 2.5rem;
  max-width: 38rem;
`;

export const StyledFootNote = styled.p`
  margin: 1rem 0 0;
  font-size: 0.8rem;
  font-style: italic;
  color: ${({ theme }) => theme.color.gray[700]};
`